import { render, staticRenderFns } from "./RegisterHeader.vue?vue&type=template&id=d4a587d6&scoped=true&"
import script from "./RegisterHeader.vue?vue&type=script&lang=js&"
export * from "./RegisterHeader.vue?vue&type=script&lang=js&"
import style0 from "./RegisterHeader.vue?vue&type=style&index=0&id=d4a587d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a587d6",
  null
  
)

export default component.exports